/**
 * 错误码定义模块
 * 
 * @module api/errorCodes
 * @description 定义系统中所有的业务错误码和错误信息映射
 * @author 汪浩
 * @copyright 武汉职创未来科技有限公司
 */

/**
 * 错误码常量定义
 */
export const ERROR_CODES = {
  /** 成功 */
  SUCCESS: 0,
  /** 手机号格式错误 */
  PHONE_FORMAT_ERROR: 200001,
  /** 短信验证码错误 */
  SMS_CODE_ERROR: 200002,
  /** 短信验证码已过期 */
  SMS_CODE_EXPIRED: 200003,
  /** 手机号未注册 */
  PHONE_NOT_REGISTERED: 200004,
  /** 账号已禁用 */
  ACCOUNT_DISABLED: 200005,
  /** 用户名或密码错误 */
  USERNAME_OR_PASSWORD_ERROR: 200006,
  /** 短信发送过于频繁 */
  SMS_TOO_FREQUENT: 200007,
  /** 密码不满足设置规则要求 */
  PASSWORD_NOT_MEET_RULES: 200008,
  /** 初次登录，需要修改密码 */
  FIRST_LOGIN_RESET_PASSWORD: 200013,
  /** 用户不存在 */
  USER_NOT_FOUND: 200014,
  /** Token过期 */
  TOKEN_EXPIRED: 200015,
  /** 图片用途错误 */
  IMAGE_PURPOSE_ERROR: 200016,
  /** 服务器内部异常 */
  SERVER_ERROR: 500001
} as const

/**
 * 错误信息映射表
 * 将错误码映射为对应的中文错误提示信息
 */
export const ERROR_MESSAGES: Record<number, string> = {
  [ERROR_CODES.SUCCESS]: '成功',
  [ERROR_CODES.PHONE_FORMAT_ERROR]: '手机号格式错误',
  [ERROR_CODES.SMS_CODE_ERROR]: '短信验证码错误',
  [ERROR_CODES.SMS_CODE_EXPIRED]: '短信验证码已过期',
  [ERROR_CODES.PHONE_NOT_REGISTERED]: '手机号未注册，请联系管理员',
  [ERROR_CODES.ACCOUNT_DISABLED]: '账号已禁用',
  [ERROR_CODES.USERNAME_OR_PASSWORD_ERROR]: '用户名或密码错误',
  [ERROR_CODES.SMS_TOO_FREQUENT]: '短信发送过于频繁，请稍后再试',
  [ERROR_CODES.PASSWORD_NOT_MEET_RULES]: '密码不满足设置规则要求',
  [ERROR_CODES.FIRST_LOGIN_RESET_PASSWORD]: '初次登录，请重置密码',
  [ERROR_CODES.USER_NOT_FOUND]: '用户不存在',
  [ERROR_CODES.TOKEN_EXPIRED]: 'Token已过期，请重新登录',
  [ERROR_CODES.IMAGE_PURPOSE_ERROR]: '图片用途错误',
  [ERROR_CODES.SERVER_ERROR]: '服务器内部异常',
  500: '网络异常，请检查网络连接'
}

/**
 * 根据错误码获取错误信息
 * 
 * @param code - 错误码
 * @returns 对应的错误提示信息，如果找不到则返回'未知错误'
 */
export const getErrorMessage = (code: number): string => {
  return ERROR_MESSAGES[code] || '未知错误'
}
